export const ChronologicalCommentsSort = {
  OldestFirst: 'oldest-first',
  NewestFirst: 'newest-first',
} as const

export type ChronologicalCommentsSort = (typeof ChronologicalCommentsSort)[keyof typeof ChronologicalCommentsSort]

export function isChronologicalCommentsSort(value: unknown): value is ChronologicalCommentsSort {
  return value === ChronologicalCommentsSort.OldestFirst || value === ChronologicalCommentsSort.NewestFirst
}
